import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { mustMatch } from './custom-matching-validator';

@Directive({
  selector: '[routingMatch]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomRoutingMatchDirective, multi: true }]
})

export class CustomRoutingMatchDirective implements Validator {
  @Input('routingMatch') mustMatch: string[] = [];

  validate(formGroup: FormGroup): ValidationErrors {
    return mustMatch(this.mustMatch[0], this.mustMatch[1])(formGroup);
  }
}
